<template>
  <div class="book-unit book-unit--highlights">
    <a
      class="book-unit__link-box book-unit__link-box--highlights"
      @click="$emit('unitClick')"
    >
      <BookCardThumbnail
        class="book-unit__img list-c"
        coverClass="list-card"
        fallbackCoverClass="list-card"
        :doc="book"
      />

      <div class="book-unit__highlights-text">
        <div class="book-unit__text book-unit__text--highlights">
          <div class="book-unit__text-c card-text">
            <h3 class="card-text__name">
              <a @click="$emit('unitClick')"> {{ book.title }} </a>
            </h3>
            <h4 class="card-text__author card-text__author--no-margin">
              By {{ book.author }}
            </h4>
          </div>
        </div>
        <div class="book-unit__bottom-box--highlights">
          <span v-if="book.highlights_count" class="book-unit__highlights-link">
            <span class="highlights__icon iconfont ihighlights" />
            <span> {{ book.highlights_count }} </span>
            <i class="book-unit__highlights-messages">{{
              getHighlightsWord(book.highlights_count)
            }}</i></span
          >
          <span v-if="book.notes_count" class="book-unit__highlights-link">
            <span class="highlights__icon iconfont inotes" />
            <span> {{ book.notes_count }} </span>
            <i class="book-unit__highlights-messages">{{
              getNotesWord(book.notes_count)
            }}</i></span
          >
          <span v-if="book.bookmarks_count" class="book-unit__highlights-link">
            <span class="highlights__icon iconfont iflag" />
            <span> {{ book.bookmarks_count }} </span>
            <i class="book-unit__highlights-messages">{{
              getBookmarksWord(book.bookmarks_count)
            }}</i></span
          >
        </div>
      </div>
    </a>
  </div>
</template>

<script setup lang="ts">
import type { HighlightsAllDoc } from '@/models/interfaces'

import BookCardThumbnail from '@/app/components/book/card/BookCardThumbnail.vue'

defineProps<{
  book: HighlightsAllDoc
}>()

defineEmits<{
  (e: 'unitClick'): void
}>()

function getNotesWord(notes: number): string {
  return notes === 1 ? `Note` : `Notes`
}

function getHighlightsWord(highlights: number): string {
  return highlights === 1 ? `Highlight` : `Highlights`
}

function getBookmarksWord(bookmarks: number): string {
  return bookmarks === 1 ? `Bookmark` : `Bookmarks`
}
</script>
